// Hook para detectar plataforma e usar método correto
import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export const usePlatform = () => {
  const [isIOS, setIsIOS] = useState(false);
  const [isWeb, setIsWeb] = useState(true);

  useEffect(() => {
    const platform = Capacitor.getPlatform();
    setIsIOS(platform === 'ios');
    setIsWeb(platform === 'web');
  }, []);

  return { isIOS, isWeb, platform: Capacitor.getPlatform() };
};

// Produtos IAP (IDs do App Store Connect)
export const IAP_PRODUCTS = {
  premium: 'com.mairecipes.premium.individual',
  family: 'com.mairecipes.premium.family'
};

// Hook de assinatura que usa StoreKit ou Stripe
export const useSubscription = () => {
  const { isIOS } = usePlatform();
  
  const subscribe = async (plan) => {
    if (isIOS) {
      // Usar StoreKit
      return await subscribeWithStoreKit(plan);
    } else {
      // Usar Stripe
      return await subscribeWithStripe(plan);
    }
  };
  
  return { subscribe, isIOS };
};

const subscribeWithStoreKit = async (plan) => {
  // Implementação StoreKit
  const productId = IAP_PRODUCTS[plan];
  
  try {
    const { InAppPurchase2 } = await import('@awesome-cordova-plugins/in-app-purchase-2');
    const store = InAppPurchase2.store;
    
    // Registrar produto
    store.register({
      id: productId,
      type: store.PAID_SUBSCRIPTION
    });
    
    // Comprar
    return new Promise((resolve, reject) => {
      store.when(productId).approved((product) => {
        product.finish();
        resolve({ success: true, platform: 'ios' });
      });
      
      store.when(productId).error((error) => {
        reject(error);
      });
      
      store.order(productId);
      store.refresh();
    });
  } catch (error) {
    throw error;
  }
};

const subscribeWithStripe = async (plan) => {
  // Implementação Stripe (já existente)
  const response = await fetch('/api/subscription/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ plan, origin_url: window.location.origin })
  });
  
  const data = await response.json();
  
  if (data.url) {
    window.location.href = data.url;
  }
  
  return { success: true, platform: 'web' };
};
